import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import CoastalHeader from './components/CoastalHeader';
import CoastalFooter from './components/CoastalFooter';
import USFlags from './pages/USFlags';
import StateFlags from './pages/StateFlags';
import Military from './pages/Military';
import Poles from './pages/Poles';
import Custom from './pages/Custom';
import Installation from './pages/Installation';
import Cart from './pages/Cart';
import CoastalHome from './pages/CoastalHome';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import './App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <CoastalHeader />
        <main>
          <Routes>
            {/* Coastal Flag Company Routes */}
            <Route path="/" element={<CoastalHome />} />
            <Route path="/us-flags" element={<USFlags />} />
            <Route path="/state-flags" element={<StateFlags />} />
            <Route path="/military" element={<Military />} />
            <Route path="/marine" element={<USFlags />} />
            <Route path="/poles" element={<Poles />} />
            <Route path="/custom" element={<Custom />} />
            <Route path="/installation" element={<Installation />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
          </Routes>
        </main>
        <CoastalFooter />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;